import { Injectable, inject } from '@angular/core';
import { MessageService , ConfirmationService} from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorResponse } from '@/types/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private messageService = inject(MessageService);
  private confirmation = inject(ConfirmationService);

  showSuccess(summary: string, detail: string) {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life: 3000
    });
  }

  showError(summary: string, detail: string) {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life: 3000
    });
  }

  showInfo(summary: string, detail: string) {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      life: 3000
    });
  }

  showWarn(summary: string, detail: string) {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      life: 3000
    });
  }

  handleHttpError(err: HttpErrorResponse) {
    const errorBody = err.error as ApiErrorResponse;
    const beMessage = errorBody?.message;

    const detail = Array.isArray(beMessage)
      ? beMessage.join(', ')
      : (beMessage || 'server internal error');

    const summary = errorBody?.error || 'Failed';

    this.showError(summary, detail);
  }

 confirm(
  message: string,
  header: string,
  accept: () => void,
  icon: string = 'pi pi-exclamation-triangle'
) {
  console.log('Memicu dialog konfirmasi...'); // Debug
  this.confirmation.confirm({
    message,
    header,
    icon,
    accept: () => {
      console.log('User menekan tombol "Yes"'); // Debug
      accept();
    },
    reject: () => {
      console.log('User menekan tombol "No" atau menutup dialog'); // Debug
    }
  });
}
}
